import { CouponModalJsEnv } from './coupon_modal_js_env';
import { Coupon } from './coupon_information';

export class CouponModalState {
  constructor(private model: CouponModalJsEnv) {
    this.model = { ...model };
  }

  getModel(): CouponModalJsEnv {
    return {
      ...this.model
    };
  }

  updateShouldShowModal(shouldShowModal: boolean) {
    this.model.shouldShowModal = shouldShowModal;
  }

  updateCoupons(coupons: Coupon[]) {
    this.model.coupons = coupons;
  }

  updateCatalogItemCode(catalogItemCode: string) {
    this.model.catalogItemCode = catalogItemCode;
  }
}
